




































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ProjectChooser from '@/components/utils/ProjectChooser.vue';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { Project } from '@/models/project';

// noinspection TypeScriptCheckImport
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar';
import type { XAppliedLesson } from '@/models/xappliedlesson';

/**
 * Internal helper Interface build by the same structure used in
 * https://github.com/richardtallent/vue-simple-calendar/#calendar-event-properties
 */
interface CalendarEvent {
    id: string;
    title: string;
    startDate: Date;
    endDate: Date;
    url: string;
    classes: string;
    style: string;
    appliedLesson: AppliedLesson | null;
    pmAppliedLesson: PMAppliedLesson | null;
    xAppliedLesson: XAppliedLesson | null;
    originalEvent: CalendarEvent;
}

@Component({
    name: 'Reports',
    components: {
        ProjectChooser,
        CalendarView,
        CalendarViewHeader,
    },
})
export default class Reports extends Vue {
    private showDate: Date = new Date();

    private events: CalendarEvent[] = [];

    private headerProps = {
        currentPeriod: new Date(),
    };
    @Getter('project/selectedProject') private selectedProject: Project;

    @Action('worksheet/fetchAllToDos') private fetchAllToDos;

    @Getter('worksheet/toDoAppliedLessons') private toDoAppliedLessons: AppliedLesson[];
    @Getter('worksheet/toDoPMAppliedLessons') private toDoPMAppliedLessons: PMAppliedLesson[];
    @Getter('worksheet/toDoXAppliedLessons') private toDoXAppliedLessons: XAppliedLesson[];

    private mounted() {
        this.fetchAllToDos();
        this.processAppliedLessons();
    }

    private processAppliedLessons() {
        let eventId: number = this.events.length;
        this.toDoAppliedLessons.forEach((appliedLesson: AppliedLesson) => {
            if (appliedLesson.contacttill) {
                const calendarEvent = {} as CalendarEvent;
                calendarEvent.id = eventId.toString();
                calendarEvent.title = appliedLesson.todo;
                calendarEvent.startDate = appliedLesson.contacttill;
                calendarEvent.appliedLesson = appliedLesson;
                calendarEvent.classes = 'prine-cv-event';
                this.events.push(calendarEvent);
                ++eventId;
            }
        });
        this.processPmAppliedLessons();
    }

    private processPmAppliedLessons() {
        let eventId: number = this.events.length;
        this.toDoPMAppliedLessons.forEach((appliedLesson: PMAppliedLesson) => {
            if (appliedLesson.contacttill) {
                const calendarEvent = {} as CalendarEvent;
                calendarEvent.id = eventId.toString();
                calendarEvent.title = appliedLesson.todo;
                calendarEvent.startDate = appliedLesson.contacttill;
                calendarEvent.pmAppliedLesson = appliedLesson;
                calendarEvent.classes = 'prine-cv-event';
                this.events.push(calendarEvent);
                ++eventId;
            }
        });
        this.processXAppliedLessons();
    }

    private processXAppliedLessons() {
        let eventId: number = this.events.length;
        this.toDoXAppliedLessons.forEach((appliedLesson: XAppliedLesson) => {
            if (appliedLesson.contacttill) {
                const calendarEvent = {} as CalendarEvent;
                calendarEvent.id = eventId.toString();
                calendarEvent.title = appliedLesson.todo;
                calendarEvent.startDate = appliedLesson.contacttill;
                calendarEvent.xAppliedLesson = appliedLesson;
                calendarEvent.classes = 'prine-cv-event';
                this.events.push(calendarEvent);
                ++eventId;
            }
        });
    }

    private setShowDate(d) {
        this.showDate = d;
    }

    private eventClicked(event: CalendarEvent) {
        switch (true) {
            case !!event.originalEvent.appliedLesson:
                if (!event.originalEvent.appliedLesson) {
                    return;
                }

                this.$store.commit('utils/setCurrentRoutePath', '/projects');
                this.$router.push({
                    name: 'WorksheetView',
                    query: {
                        id: event.originalEvent.appliedLesson.worksheet_id.toString(),
                        type: null,
                        highlight: event.originalEvent.appliedLesson.id.toString(),
                    },
                });
                break;

            case !!event.originalEvent.pmAppliedLesson:
                if (!event.originalEvent.pmAppliedLesson) {
                    return;
                }

                this.$store.commit('utils/setCurrentRoutePath', '/projects');
                this.$router.push({
                    name: 'WorksheetView',
                    query: {
                        id: event.originalEvent.pmAppliedLesson.pm_worksheet_id.toString(),
                        type: 'pm',
                        highlight: event.originalEvent.pmAppliedLesson.id.toString(),
                    },
                });
                break;

            case !!event.originalEvent.xAppliedLesson:
                if (!event.originalEvent.xAppliedLesson) {
                    return;
                }

                this.$store.commit('utils/setCurrentRoutePath', '/projects');
                this.$router.push({
                    name: 'WorksheetView',
                    query: {
                        id: event.originalEvent.xAppliedLesson.x_worksheet_id.toString(),
                        type: 'x',
                        highlight: event.originalEvent.xAppliedLesson.id.toString(),
                    },
                });
                break;
        }
    }
}
